import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import FormMultiEditCandidato from "./formMultiEditCandidatoNp";

const MultiEditCandidatoFormModal = ({ toggle, isOpen, info, handleMultiEditCandidatos, vacantes, cobertura, derivacionId, notaDePedidoId, canCreateOV }) => {
  return (
    <div>
      <Modal isOpen={isOpen} centered style={{ fontFamily: "Nunito" }}>
        <ModalHeader toggle={toggle} style={{ borderBottom: "none", background: " #f8f8f8" }}>
          Editar candidatos
        </ModalHeader>
        <ModalBody style={{ background: " #f8f8f8" }}>
          <FormMultiEditCandidato
            toggle={toggle}
            info={info}
            handleMultiEditCandidatos={handleMultiEditCandidatos}
            vacantes={vacantes}
            cobertura={cobertura}
            derivacionId={derivacionId}
            notaDePedidoId={notaDePedidoId}
            canCreateOV={canCreateOV}
          />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default MultiEditCandidatoFormModal;
